export const img1_linuxCloud = require("./worry_free_linux_installations.svg");
export const img2 = require("./one_device_is_all_you_need.svg");
export const img3 = require("./take_your_linux_machine_anywhere.svg");
export const img4 = require("./multiple_linux_distros_options.svg");
export const img5 = require("./sharing_resources.svg");
